<template>
  <div class="step" v-for="step in steps" :key="step.id">
    <div class="step__title" @click="toggleStep(step.id)">
      <div class="step">{{ step.step }}</div>
      <div class="title">{{ step.title }}</div>
      <img
        :class="{ rotate: isOpen(step.id), opacity: step.id === 6 }"
        src="@/assets/images/icons/plus-white.png"
        alt="icon"
      />
    </div>
    <div class="step__content" v-if="isOpen(step.id)">
      <ul>
        <li v-for="content in step.content" :key="content.id">
          <p v-if="content.step" class="num">{{ content.step }}</p>
          <p>{{ content.text }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "recruiting-content-item",
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      openSteps: [],
    };
  },
  methods: {
    toggleStep(stepId) {
      if (this.isOpen(stepId)) {
        this.openSteps = this.openSteps.filter((id) => id !== stepId);
      } else {
        this.openSteps.push(stepId);
      }
    },
    isOpen(stepId) {
      if (stepId !== 6) {
        return this.openSteps.includes(stepId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.step {
  &:last-child {
    margin-bottom: 40px;
  }
  &__title {
    border-top: 1px solid white;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-family: UAF Sans;
    font-weight: 500;
    font-size: 24px;
    text-transform: uppercase;
    padding-top: 22px;
    height: 95px;
    cursor: pointer;

    @media (max-width: 767px) {
      height: 70px;
      gap: 12px;
      padding: 10px 0;
      align-items: center;
    }

    &:last-child {
      border-bottom: 1px solid white;
    }

    .step {
      font-size: 32px;
      line-height: 100%;
      font-family: "UAF Sans HR", serif;

      @media (max-width: 767px) {
        font-size: 24px;
      }
    }

    .title {
      font-family: "UAF Sans HR", serif;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      text-transform: uppercase;
      width: 425px;

      @media (max-width: 767px) {
        font-size: 18px;
        line-height: 20px;
      }
    }

    img {
      width: 44px;
      transition: 0.3s;

      @media (max-width: 767px) {
        width: 22px;
      }
    }
  }

  &__content {
    ul {
      width: 425px;
      margin: 0 auto 55px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      @media (max-width: 767px) {
        margin: 30px auto;
      }
    }
    li {
      list-style-type: none;
      font-family: UAF Sans, serif;
      font-weight: 400;
      font-size: 24px;
      line-height: 100%;
      display: flex;
      width: 500px;

      @media (max-width: 767px) {
        line-height: 23px;
        display: flex;
        width: 100%;
        font-size: 18px;
      }

      p {
        max-width: max-content;
        width: 445px;
        line-height: 30px;

        @media (max-width: 767px) {
          width: 70%;
        }

        &.num {
          margin-right: 50px;
          width: 35px;
          display: block;
          font-family: "UAF Sans HR", serif;
        }
      }
    }
  }
}

.rotate {
  transform: rotate(135deg);
  transition: 0.3s;
}

.opacity {
  opacity: 0;
}
</style>
